import { useState, useEffect, useRef } from 'react';

const API_BASE      = 'https://feitevmd2k.execute-api.ap-south-1.amazonaws.com/prod';
const CRM_API       = `${API_BASE}/public/leads`;
const FEEDBACK_API  = `${API_BASE}/public/feedback`;
const LOOKUP_API    = `${API_BASE}/public/customer-lookup`;
// Update to your actual Google Business review link
const GOOGLE_REVIEW_URL = 'https://g.page/r/CeKJOJGuvEHAEAE/review';
const RATINGS = [5, 4, 3, 2, 1];

const PACKAGES = [
  { id: '2d1n', label: '2 Days / 1 Night',  sub: 'Ooty & Coonoor',                        icon: '🌿' },
  { id: '3d2n', label: '3 Days / 2 Nights', sub: 'Ooty + Pykara + Coonoor',               icon: '🏔️' },
  { id: '4d3n', label: '4 Days / 3 Nights', sub: 'Ooty + Pykara + Mudumalai + Coonoor',   icon: '🐘' },
  { id: 'custom', label: 'Custom Package',  sub: 'Tell us your requirements',              icon: '✨' },
];


const LOCATIONS = [
  { label: 'Ooty',                      icon: '🌿' },
  { label: 'Mettupalayam',              icon: '🚉' },
  { label: 'Coimbatore',                icon: '✈️' },
  { label: 'Mysore',                    icon: '🏰' },
  { label: 'Bangalore',                 icon: '🌆' },
  { label: 'Chennai',                   icon: '🌊' },
  { label: 'Other (mention in notes)',  icon: '📍' },
];

// Enquiry steps: 0 welcome | 1 email | 2 package | 3 date | 4 adults | 5 children
//                6 pickup | 7 drop | 8 name | 9 phone | 10 confirm | 11 done
// Review steps:  20 email | 21 rating | 22 comment | 23 done | 99 browsing

const BOT_MESSAGES = {
  welcome:  "👋 Hi! Welcome to OotyGo 🌿\nHow can we help you today?",
  email:    "First, what's your email address? ✉️\n(So we can find or set up your profile)",
  package:  "Great! Which package are you interested in?",
  dates:    "When are you planning to travel? 📅\nPlease select your travel date:",
  adults:   "How many adults are travelling (above 10 years)? 🧑\n(Enter the number)",
  children: "How many children? 🧒\n(Below 10 years — enter 0 if none)",
  pickup:   "Where should we pick you up? 📍",
  drop:     "Where should we drop you after the tour? 🏁",
  name:     "What's your name?",
  phone:    "Your WhatsApp / phone number? 📱",
  done:     "✅ Thank you! Our team will contact you shortly on WhatsApp.\n\nHave a wonderful trip to Ooty! 🌿",
  // Review flow
  reviewEmail:   "We'd love your feedback! ✨\nFirst, your email address? ✉️",
  reviewRating:  "How would you rate your OotyGo experience? ⭐",
  reviewComment: "Tell us about your trip! 📝\n(A few words — type 'skip' to leave blank)",
  reviewDone:    "🙏 Thank you for your review! It means the world to us.",
};

// ── Styles ──────────────────────────────────────────────────────────
const GREEN  = '#1a5c3a';
const GREEN2 = '#2e7d52';
const LIGHT  = '#e8f5e9';

const S = {
  fabWrap: {
    position: 'fixed', zIndex: 9999,
    transition: 'left 2.4s cubic-bezier(.34,.6,.4,1), top 2.4s cubic-bezier(.34,.6,.4,1)',
  },
  fab: {
    width: 62, height: 62, borderRadius: '50%',
    background: `linear-gradient(135deg,${GREEN},${GREEN2})`,
    boxShadow: '0 6px 22px rgba(26,92,58,0.5)',
    border: 'none', cursor: 'pointer',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    transition: 'transform 0.2s',
  },
  botBob: { display: 'flex', animation: 'ootygoBob 2.2s ease-in-out infinite' },
  fabBubble: {
    position: 'absolute', bottom: 72, right: 0,
    background: '#fff', color: GREEN,
    padding: '10px 14px', borderRadius: 14,
    borderBottomRightRadius: 4,
    boxShadow: '0 4px 18px rgba(0,0,0,0.18)',
    fontFamily: "'Segoe UI', Helvetica, Arial, sans-serif",
    fontSize: 13, fontWeight: 600, lineHeight: 1.3,
    width: 168, cursor: 'pointer',
    display: 'flex', alignItems: 'center', gap: 8,
    animation: 'ootygoBubbleIn 0.4s ease',
  },
  fabBubbleClose: {
    background: 'rgba(0,0,0,0.06)', border: 'none', borderRadius: '50%',
    width: 18, height: 18, lineHeight: '16px', cursor: 'pointer',
    color: '#888', fontSize: 12, flexShrink: 0, padding: 0,
  },
  window: {
    position: 'fixed', bottom: 96, right: 24, zIndex: 9999,
    width: 360, maxHeight: 580,
    borderRadius: 16,
    boxShadow: '0 8px 40px rgba(0,0,0,0.18)',
    display: 'flex', flexDirection: 'column',
    fontFamily: "'Segoe UI', Helvetica, Arial, sans-serif",
    overflow: 'hidden',
    background: '#fff',
  },
  header: {
    background: `linear-gradient(135deg,${GREEN},${GREEN2})`,
    padding: '14px 18px',
    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
    flexShrink: 0,
  },
  headerLeft: { display: 'flex', alignItems: 'center', gap: 10 },
  avatar: {
    width: 38, height: 38, borderRadius: '50%',
    background: 'rgba(255,255,255,0.2)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontSize: 20,
  },
  headerName: { color: '#fff', fontWeight: 700, fontSize: 15, margin: 0 },
  headerSub:  { color: '#a7d4b8', fontSize: 11, margin: 0 },
  closeBtn: {
    background: 'none', border: 'none', color: '#fff',
    fontSize: 20, cursor: 'pointer', lineHeight: 1, padding: 4,
  },
  body: {
    flex: 1, overflowY: 'auto', padding: '16px 14px',
    display: 'flex', flexDirection: 'column', gap: 10,
    background: '#f7f9f7',
  },
  botBubble: {
    alignSelf: 'flex-start',
    background: '#fff',
    border: `1px solid ${LIGHT}`,
    borderRadius: '0 14px 14px 14px',
    padding: '10px 14px',
    maxWidth: '84%',
    fontSize: 13.5,
    color: '#222',
    lineHeight: 1.55,
    boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
    whiteSpace: 'pre-line',
  },
  userBubble: {
    alignSelf: 'flex-end',
    background: `linear-gradient(135deg,${GREEN},${GREEN2})`,
    borderRadius: '14px 0 14px 14px',
    padding: '10px 14px',
    maxWidth: '78%',
    fontSize: 13.5,
    color: '#fff',
    lineHeight: 1.55,
  },
  optionRow: {
    display: 'flex', flexDirection: 'column', gap: 7,
    alignSelf: 'flex-start', width: '100%',
  },
  optionBtn: {
    background: '#fff', border: `1.5px solid ${GREEN2}`,
    borderRadius: 10, padding: '9px 14px',
    fontSize: 13, color: GREEN, fontWeight: 600,
    cursor: 'pointer', textAlign: 'left',
    display: 'flex', alignItems: 'center', gap: 8,
    transition: 'background 0.15s',
  },
  optionBtnSub: { fontSize: 11, color: '#666', fontWeight: 400 },
  // Date picker card rendered inline in chat
  dateCard: {
    background: '#fff',
    border: `1.5px solid ${GREEN2}`,
    borderRadius: 12, padding: '14px',
    alignSelf: 'flex-start', width: '92%',
  },
  dateLabel: { fontSize: 12, color: GREEN, fontWeight: 700, marginBottom: 6, display: 'block' },
  dateInput: {
    width: '100%', border: `1.5px solid #cde0cd`,
    borderRadius: 8, padding: '9px 12px',
    fontSize: 14, outline: 'none',
    fontFamily: 'inherit', boxSizing: 'border-box',
    color: '#333',
  },
  dateConfirmBtn: {
    marginTop: 10, width: '100%',
    background: `linear-gradient(135deg,${GREEN},${GREEN2})`,
    border: 'none', borderRadius: 8,
    padding: '10px', fontSize: 13.5, fontWeight: 700,
    color: '#fff', cursor: 'pointer',
  },
  inputRow: {
    display: 'flex', gap: 8, padding: '12px 14px',
    borderTop: '1px solid #e8ece8',
    background: '#fff', flexShrink: 0,
  },
  textInput: {
    flex: 1, border: '1.5px solid #cde0cd',
    borderRadius: 10, padding: '10px 14px',
    fontSize: 13.5, outline: 'none',
    fontFamily: 'inherit',
  },
  sendBtn: {
    background: `linear-gradient(135deg,${GREEN},${GREEN2})`,
    border: 'none', borderRadius: 10,
    width: 44, height: 44, flexShrink: 0,
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    cursor: 'pointer', fontSize: 18, color: '#fff',
  },
  confirmBox: {
    background: LIGHT, border: `1px solid #b2dfb2`,
    borderRadius: 12, padding: '12px 14px',
    fontSize: 12.5, color: '#333', lineHeight: 1.8,
    alignSelf: 'flex-start', width: '100%',
    boxSizing: 'border-box',
  },
  submitBtn: {
    background: `linear-gradient(135deg,${GREEN},${GREEN2})`,
    border: 'none', borderRadius: 10,
    padding: '11px 20px', fontSize: 14, fontWeight: 700,
    color: '#fff', cursor: 'pointer', width: '100%',
    marginTop: 6,
  },
  typingDot: {
    display: 'inline-block', width: 7, height: 7,
    borderRadius: '50%', background: '#aaa', margin: '0 2px',
  },
};

// ── Helpers ──────────────────────────────────────────────────────────
function todayStr() {
  return new Date().toISOString().slice(0, 10);
}
function formatDate(iso) {
  if (!iso) return '';
  const [y, m, d] = iso.split('-');
  const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  return `${d} ${months[Number(m) - 1]} ${y}`;
}

// ── Cute animated robot mascot icon ──────────────────────────────────
function BotIcon() {
  return (
    <svg width="34" height="34" viewBox="0 0 40 40" fill="none" aria-hidden="true">
      {/* antenna */}
      <line x1="20" y1="2.5" x2="20" y2="9" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" />
      <circle cx="20" cy="2.6" r="2.5" fill="#fff" className="ootygo-antenna" />
      {/* ears */}
      <rect x="4.5" y="15" width="3.2" height="8" rx="1.6" fill="#fff" />
      <rect x="32.3" y="15" width="3.2" height="8" rx="1.6" fill="#fff" />
      {/* head */}
      <rect x="8" y="9" width="24" height="20" rx="7.5" fill="#fff" />
      {/* eyes (blink) */}
      <g className="ootygo-eyes" fill={GREEN}>
        <circle cx="15.5" cy="18" r="2.5" />
        <circle cx="24.5" cy="18" r="2.5" />
      </g>
      {/* cheeks */}
      <circle cx="12" cy="22" r="1.5" fill="#ffb3c1" opacity="0.85" />
      <circle cx="28" cy="22" r="1.5" fill="#ffb3c1" opacity="0.85" />
      {/* smile */}
      <path d="M15.5 23.5 Q20 27 24.5 23.5" stroke={GREEN} strokeWidth="2" strokeLinecap="round" fill="none" />
    </svg>
  );
}

// ── Component ────────────────────────────────────────────────────────
export default function ChatWidget() {
  const [open, setOpen]           = useState(false);
  const [step, setStep]           = useState(0);
  const [messages, setMessages]   = useState([]);
  const [input, setInput]         = useState('');
  const [dateVal, setDateVal]     = useState(todayStr());
  const [typing, setTyping]       = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [rating, setRating]       = useState(0);
  const [showBubble, setShowBubble] = useState(true);
  const [pos, setPos]             = useState({ left: -200, top: -200 });
  const [reaction, setReaction]   = useState(null); // { emoji, id } cute pop

  // Keep the mascot pinned to a fixed bottom-right corner.
  useEffect(() => {
    const SIZE = 62;
    const dock = () => setPos({
      left: window.innerWidth  - SIZE - 24,
      top:  window.innerHeight - SIZE - 24,
    });
    dock();
    window.addEventListener('resize', dock);
    return () => window.removeEventListener('resize', dock);
  }, [open]);
  const [, setLead] = useState({});
  const leadRef     = useRef({});   // always holds latest lead values
  const knownName   = useRef('');   // name from CRM email lookup (returning customer)
  const bodyRef     = useRef(null);

  // keep leadRef in sync with lead state
  function updateLead(updater) {
    setLead((prev) => {
      const next = typeof updater === 'function' ? updater(prev) : updater;
      leadRef.current = next;
      return next;
    });
  }

  useEffect(() => {
    if (bodyRef.current) bodyRef.current.scrollTop = bodyRef.current.scrollHeight;
  }, [messages, typing]);

  useEffect(() => {
    if (open && messages.length === 0) addBotMsg(BOT_MESSAGES.welcome, 400);
  }, [open]); // eslint-disable-line

  function addBotMsg(text, delay = 650) {
    setTyping(true);
    setTimeout(() => {
      setTyping(false);
      setMessages((prev) => [...prev, { from: 'bot', text }]);
    }, delay);
  }
  function addUserMsg(text) {
    setMessages((prev) => [...prev, { from: 'user', text }]);
  }

  // Cute animated emoji that pops, bounces and floats up inside the chat.
  function popReaction(emoji) {
    const id = Date.now() + Math.random();
    setReaction({ emoji, id });
    setTimeout(() => setReaction((r) => (r && r.id === id ? null : r)), 1200);
  }

  // Look up a customer by email — returns name if found
  async function lookupCustomer(email) {
    try {
      const res = await fetch(`${LOOKUP_API}?email=${encodeURIComponent(email)}`);
      const data = await res.json();
      return data.found ? (data.name || '') : '';
    } catch { return ''; }
  }

  // ── Handlers ────────────────────────────────────────────────────────

  function handleStart() {
    addUserMsg("🎉 Plan my trip");
    updateLead({});
    knownName.current = '';
    setStep(1);                       // email FIRST
    addBotMsg(BOT_MESSAGES.email);
  }

  function handleReviewStart() {
    addUserMsg("⭐ Leave a review");
    updateLead({});
    knownName.current = '';
    setStep(20);                      // review email first
    addBotMsg(BOT_MESSAGES.reviewEmail);
  }

  function handlePackage(pkg) {
    addUserMsg(`${pkg.icon} ${pkg.label}`);
    popReaction('🌿');
    updateLead((l) => ({ ...l, package: pkg.label }));
    setStep(3);
    addBotMsg(`Ooh, ${pkg.label} — lovely choice! 🌿✨`);
    addBotMsg(BOT_MESSAGES.dates, 1200);
  }

  function handleDateConfirm() {
    if (!dateVal) return;
    const label = formatDate(dateVal);
    addUserMsg(`📅 ${label}`);
    popReaction('📅');
    updateLead((l) => ({ ...l, date: label, dateIso: dateVal }));
    setStep(4);
    addBotMsg(`Yay! ${label} it is 🎉`);
    addBotMsg(BOT_MESSAGES.adults, 1200);
  }

  function handlePickup(loc) {
    addUserMsg(`📍 ${loc.label}`);
    popReaction('🚗');
    updateLead((l) => ({ ...l, pickup: loc.label }));
    setStep(7);
    addBotMsg(BOT_MESSAGES.drop);
  }

  function handleDrop(loc) {
    addUserMsg(`🏁 ${loc.label}`);
    popReaction('🗺️');
    updateLead((l) => ({ ...l, drop: loc.label }));
    // Returning customer? skip the name question.
    if (knownName.current) {
      updateLead((l) => ({ ...l, name: knownName.current }));
      setStep(9);
      addBotMsg(BOT_MESSAGES.phone);
    } else {
      setStep(8);
      addBotMsg(BOT_MESSAGES.name);
    }
  }

  function handleRating(r) {
    setRating(r);
    addUserMsg('⭐'.repeat(r));
    updateLead((l) => ({ ...l, rating: r }));
    setStep(22);
    addBotMsg(BOT_MESSAGES.reviewComment);
  }

  const isEmail = (v) => /\S+@\S+\.\S+/.test(v);

  async function handleTextSubmit() {
    const val = input.trim();
    if (!val) return;

    // ── Email steps (mandatory) — enquiry (1) & review (20) ──
    if (step === 1 || step === 20) {
      if (!isEmail(val)) { addBotMsg("Please enter a valid email address ✉️"); return; }
      setInput('');
      addUserMsg(val);
      updateLead((l) => ({ ...l, email: val }));
      const name = await lookupCustomer(val);
      knownName.current = name;
      if (name) addBotMsg(`Welcome back, ${name}! 🌿 Great to see you again.`);
      if (step === 1) {
        setStep(2);
        addBotMsg(BOT_MESSAGES.package, name ? 1100 : 650);
      } else {
        setStep(21);
        addBotMsg(BOT_MESSAGES.reviewRating, name ? 1100 : 650);
      }
      return;
    }

    setInput('');
    if (step === 4) {                 // adults
      if (!/^\d+$/.test(val)) { setInput(val); return; }
      addUserMsg(`🧑 ${val} adult${val === '1' ? '' : 's'}`);
      popReaction('🧑‍🤝‍🧑');
      updateLead((l) => ({ ...l, adults: val }));
      setStep(5);
      addBotMsg(BOT_MESSAGES.children);
    } else if (step === 5) {          // children
      if (!/^\d+$/.test(val)) { setInput(val); return; }
      addUserMsg(`🧒 ${val} child${val === '1' ? '' : 'ren'} (below 10)`);
      popReaction(Number(val) > 0 ? '🧸' : '👍');
      updateLead((l) => ({ ...l, children: val }));
      setStep(6);
      if (Number(val) > 0) addBotMsg('Aww, the little ones will love Ooty! 🧸');
      addBotMsg(BOT_MESSAGES.pickup, Number(val) > 0 ? 1200 : 650);
    } else if (step === 8) {          // name
      addUserMsg(val);
      popReaction('😊');
      updateLead((l) => ({ ...l, name: val }));
      setStep(9);
      addBotMsg(`Lovely to meet you, ${val}! 😊`);
      addBotMsg(BOT_MESSAGES.phone, 1200);
    } else if (step === 9) {          // phone → confirm
      addUserMsg(val);
      popReaction('🎉');
      updateLead((l) => ({ ...l, phone: val }));
      const updated = { ...leadRef.current, phone: val };
      setStep(10);
      setTimeout(() => showConfirm(updated), 700);
    } else if (step === 22) {         // review comment → submit
      const comment = val.toLowerCase() === 'skip' ? '' : val;
      addUserMsg(comment || '(no comment)');
      submitReview({ ...leadRef.current, comment });
    }
  }

  function showConfirm(data) {
    const summary =
      `📦 Package  : ${data.package}\n` +
      `📅 Date      : ${data.date}\n` +
      `🧑 Adults   : ${data.adults}\n` +
      `🧒 Children : ${data.children} (below 10)\n` +
      `📍 Pickup   : ${data.pickup}\n` +
      `🏁 Drop      : ${data.drop}\n` +
      `👤 Name     : ${data.name}\n` +
      `📱 Phone    : ${data.phone}\n` +
      `✉️  Email    : ${data.email}`;
    setMessages((prev) => [
      ...prev,
      { from: 'bot', text: "Here's your booking summary — shall I send this to our team?" },
      { from: 'confirm', summary, data },
    ]);
  }

  async function handleSubmit(data) {
    setSubmitted(true);
    addUserMsg('Yes, confirm! ✅');
    popReaction('🎉');
    setTimeout(() => popReaction('🥳'), 350);
    setTimeout(() => popReaction('🌿'), 700);

    const adults   = Number(data.adults) || 0;
    const children = Number(data.children) || 0;
    const payload = {
      name:         data.name,
      phone:        data.phone,
      email:        data.email || undefined,
      source:       'Website Chatbot',
      package:      data.package,
      travelDate:   data.dateIso,
      numPeople:    adults,
      numChildren:  children,
      guests:       `${adults} adult${adults !== 1 ? 's' : ''}${children ? ` + ${children} child${children !== 1 ? 'ren' : ''}` : ''}`,
      pickup:       data.pickup,
      drop:         data.drop,
      notes:        `Package: ${data.package} | Date: ${data.date} | Adults: ${adults} | Children (below 10): ${children} | Pickup: ${data.pickup} | Drop: ${data.drop}`,
      status:       'new',
    };

    try {
      await fetch(CRM_API, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) });
    } catch (e) { console.error('CRM submit error:', e); }

    setStep(11);
    addBotMsg(BOT_MESSAGES.done, 800);
  }

  async function submitReview(data) {
    setSubmitted(true);
    const r = Number(data.rating || rating || 0);
    try {
      await fetch(FEEDBACK_API, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: knownName.current || data.name || '',
          email: data.email || '',
          rating: r, comment: data.comment || '',
          source: 'Website Chatbot',
        }),
      });
    } catch (e) { console.error('Feedback submit error:', e); }

    setStep(23);
    addBotMsg(BOT_MESSAGES.reviewDone, 600);
    // Happy customers → nudge to Google
    if (r >= 4) {
      setTimeout(() => setMessages((prev) => [...prev, { from: 'google' }]), 1200);
    }
  }

  function resetChat() {
    setMessages([]);
    setStep(0);
    setInput('');
    setRating(0);
    knownName.current = '';
    setDateVal(todayStr());
    setSubmitted(false);
    updateLead({});
    setTimeout(() => addBotMsg(BOT_MESSAGES.welcome, 400), 100);
  }

  // ── Render ──────────────────────────────────────────────────────────
  return (
    <>
      {/* Animations: bubble entrance, gentle bob, eye blink, antenna pulse */}
      <style>{`
        @keyframes ootygoBubbleIn{from{opacity:0;transform:translateY(8px) scale(0.9)}to{opacity:1;transform:none}}
        @keyframes ootygoBob{0%,100%{transform:translateY(0) rotate(-2deg)}50%{transform:translateY(-5px) rotate(2deg)}}
        @keyframes ootygoBlink{0%,90%,100%{transform:scaleY(1)}95%{transform:scaleY(0.1)}}
        @keyframes ootygoPulse{0%,100%{opacity:1}50%{opacity:0.3}}
        @keyframes ootygoReact{0%{opacity:0;transform:translate(-50%,0) scale(0.3)}25%{opacity:1;transform:translate(-50%,-10px) scale(1.25)}45%{transform:translate(-50%,-18px) scale(1)}100%{opacity:0;transform:translate(-50%,-70px) scale(0.9)}}
        .ootygo-eyes{transform-box:fill-box;transform-origin:center;animation:ootygoBlink 4s infinite}
        .ootygo-antenna{transform-box:fill-box;transform-origin:center;animation:ootygoPulse 1.6s ease-in-out infinite}
        .ootygo-fab:hover{transform:scale(1.1)}
      `}</style>

      {/* Floating mascot launcher (bubble + button float together) */}
      <div style={{ ...S.fabWrap, left: pos.left, top: pos.top }}>
        {/* "Book your package instantly" nudge bubble */}
        {!open && showBubble && (
          <div style={S.fabBubble} onClick={() => { setShowBubble(false); setOpen(true); }}>
            <span>📦 Book your package instantly!</span>
            <button
              style={S.fabBubbleClose}
              onClick={(e) => { e.stopPropagation(); setShowBubble(false); }}
              aria-label="Dismiss"
            >✕</button>
          </div>
        )}

        <button className="ootygo-fab" style={S.fab} onClick={() => setOpen((o) => !o)} title="Chat with OotyGo">
          {open
            ? <span style={{ fontSize: 26, color: '#fff', lineHeight: 1 }}>✕</span>
            : <span style={S.botBob}><BotIcon /></span>}
        </button>
      </div>

      {/* Chat window */}
      {open && (
        <div style={S.window}>

          {/* Cute floating emoji reaction */}
          {reaction && (
            <div
              key={reaction.id}
              style={{
                position: 'absolute', left: '50%', bottom: 90, zIndex: 5,
                fontSize: 46, pointerEvents: 'none',
                animation: 'ootygoReact 1.2s ease-out forwards',
              }}
            >{reaction.emoji}</div>
          )}

          {/* Header */}
          <div style={S.header}>
            <div style={S.headerLeft}>
              <div style={S.avatar}>🌿</div>
              <div>
                <p style={S.headerName}>OotyGo Assistant</p>
                <p style={S.headerSub}>🟢 Online — replies instantly</p>
              </div>
            </div>
            <button style={S.closeBtn} onClick={() => setOpen(false)}>✕</button>
          </div>

          {/* Messages */}
          <div style={S.body} ref={bodyRef}>

            {messages.map((msg, i) => {
              if (msg.from === 'bot') return (
                <div key={i} style={S.botBubble}>{msg.text}</div>
              );
              if (msg.from === 'user') return (
                <div key={i} style={S.userBubble}>{msg.text}</div>
              );
              if (msg.from === 'confirm') return (
                <div key={i} style={{ alignSelf: 'flex-start', width: '100%' }}>
                  <div style={S.confirmBox}>{msg.summary}</div>
                  {!submitted && (
                    <button style={S.submitBtn} onClick={() => handleSubmit(msg.data)}>
                      🚀 Send to OotyGo Team
                    </button>
                  )}
                </div>
              );
              if (msg.from === 'google') return (
                <div key={i} style={{ alignSelf: 'flex-start', width: '100%' }}>
                  <div style={{ ...S.botBubble, background: '#fff8e1', border: '1px solid #ffe082' }}>
                    Loved your trip? A Google review helps other travellers find us! 🙏
                  </div>
                  <a href={GOOGLE_REVIEW_URL} target="_blank" rel="noopener noreferrer"
                    style={{ ...S.submitBtn, display: 'block', textAlign: 'center', textDecoration: 'none', background: '#4285F4' }}>
                    ⭐ Post on Google Reviews
                  </a>
                </div>
              );
              return null;
            })}

            {/* Typing indicator */}
            {typing && (
              <div style={{ ...S.botBubble, padding: '12px 16px' }}>
                <span style={S.typingDot} className="dot1" />
                <span style={S.typingDot} className="dot2" />
                <span style={S.typingDot} className="dot3" />
              </div>
            )}

            {/* Step 0 — Welcome */}
            {step === 0 && !typing && (
              <div style={S.optionRow}>
                <button style={S.optionBtn} onClick={handleStart}>
                  🎉 Plan my trip
                </button>
                <button style={S.optionBtn} onClick={handleReviewStart}>
                  ⭐ Leave a review
                </button>
                <button style={{ ...S.optionBtn, borderColor: '#ccc', color: '#666' }}
                  onClick={() => {
                    addUserMsg('Just browsing 👀');
                    addBotMsg("No problem! Feel free to explore. Tap 💬 anytime to plan your trip. 🌿");
                    setStep(99);
                  }}>
                  👀 Just browsing
                </button>
              </div>
            )}

            {/* Step 2 — Package */}
            {step === 2 && !typing && (
              <div style={S.optionRow}>
                {PACKAGES.map((pkg) => (
                  <button key={pkg.id} style={S.optionBtn} onClick={() => handlePackage(pkg)}>
                    <span style={{ fontSize: 16 }}>{pkg.icon}</span>
                    <span>
                      <strong>{pkg.label}</strong>
                      <span style={{ display: 'block', ...S.optionBtnSub }}>{pkg.sub}</span>
                    </span>
                  </button>
                ))}
              </div>
            )}

            {/* Step 3 — Date picker */}
            {step === 3 && !typing && (
              <div style={S.dateCard}>
                <label style={S.dateLabel}>Select travel date</label>
                <input
                  type="date"
                  style={S.dateInput}
                  value={dateVal}
                  min={todayStr()}
                  onChange={(e) => setDateVal(e.target.value)}
                />
                <button style={S.dateConfirmBtn} onClick={handleDateConfirm}>
                  Confirm Date ➤
                </button>
              </div>
            )}


            {/* Step 6 — Pickup */}
            {step === 6 && !typing && (
              <div style={S.optionRow}>
                {LOCATIONS.map((loc) => (
                  <button key={loc.label} style={S.optionBtn} onClick={() => handlePickup(loc)}>
                    <span>{loc.icon}</span> {loc.label}
                  </button>
                ))}
              </div>
            )}

            {/* Step 7 — Drop */}
            {step === 7 && !typing && (
              <div style={S.optionRow}>
                {LOCATIONS.map((loc) => (
                  <button key={loc.label} style={S.optionBtn} onClick={() => handleDrop(loc)}>
                    <span>{loc.icon}</span> {loc.label}
                  </button>
                ))}
              </div>
            )}

            {/* Step 21 — Review rating */}
            {step === 21 && !typing && (
              <div style={S.optionRow}>
                {RATINGS.map((r) => (
                  <button key={r} style={S.optionBtn} onClick={() => handleRating(r)}>
                    {'⭐'.repeat(r)} <span style={S.optionBtnSub}>&nbsp;{r} star{r !== 1 ? 's' : ''}</span>
                  </button>
                ))}
              </div>
            )}

            {/* Done restart (enquiry & review) */}
            {(step === 11 || step === 23) && !typing && (
              <button style={{ ...S.optionBtn, marginTop: 4 }} onClick={resetChat}>
                🔄 Start over
              </button>
            )}

          </div>

          {/* Bottom text input */}
          {[1, 4, 5, 8, 9, 20, 22].includes(step) && (
            <div style={S.inputRow}>
              <input
                style={S.textInput}
                placeholder={
                  step === 1 || step === 20 ? 'your@email.com' :
                  step === 4 ? 'Number of adults' :
                  step === 5 ? 'Children below 10 (0 if none)' :
                  step === 8 ? 'Your full name' :
                  step === 9 ? 'WhatsApp number' :
                  'Your review (or type skip)'
                }
                value={input}
                type={(step === 4 || step === 5) ? 'number' : (step === 1 || step === 20) ? 'email' : 'text'}
                min={(step === 4 || step === 5) ? 0 : undefined}
                onChange={(e) => setInput(e.target.value)}
                onKeyDown={(e) => e.key === 'Enter' && handleTextSubmit()}
                autoFocus
              />
              <button style={S.sendBtn} onClick={handleTextSubmit}>➤</button>
            </div>
          )}
        </div>
      )}

      {/* Typing animation */}
      <style>{`
        @keyframes bounce {
          0%,80%,100% { transform: translateY(0); }
          40%          { transform: translateY(-5px); }
        }
        .dot1 { animation: bounce 1.2s infinite 0.0s; }
        .dot2 { animation: bounce 1.2s infinite 0.2s; }
        .dot3 { animation: bounce 1.2s infinite 0.4s; }
      `}</style>
    </>
  );
}
